import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Typography,
    makeStyles,
} from "@material-ui/core";
import { currencyFormatter } from "../constants";

type Props = {
    title: string;
    credit: number;
    debit: number;
    creditLabel?: string;
    debitLabel?: string;
};

const useStyles = makeStyles((theme) => ({
    card: {
        height: "100%",
        borderRadius: 12,
        border: `1px solid ${theme.palette.divider}`,
    },
    row: {
        marginBottom: theme.spacing(2),
        "&:last-child": {
            marginBottom: 0,
        },
    },
    rowHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(0.75),
    },
    label: {
        fontSize: "0.85rem",
        fontWeight: 600,
        color: theme.palette.text.secondary,
    },
    amount: {
        fontSize: "0.9rem",
        fontWeight: 700,
    },
    track: {
        height: 10,
        borderRadius: 6,
        background: theme.palette.action.hover,
        overflow: "hidden",
    },
    fill: {
        height: "100%",
        borderRadius: 6,
        transition: "width 0.4s ease",
    },
}));

const ComparisonBar = ({
    title,
    credit,
    debit,
    creditLabel = "Credit (Charges)",
    debitLabel = "Debit (Collections)",
}: Props) => {
    const classes = useStyles();
    const total = credit + debit || 1;
    const creditPct = Math.round((credit / total) * 100);
    const debitPct = Math.round((debit / total) * 100);

    return (
        <Card className={classes.card} elevation={0}>
            <CardHeader title={title} titleTypographyProps={{ variant: "h6" }} />
            <CardContent>
                <Box className={classes.row}>
                    <Box className={classes.rowHeader}>
                        <Typography className={classes.label}>
                            {creditLabel}
                        </Typography>
                        <Typography
                            className={classes.amount}
                            style={{ color: "#e65100" }}
                        >
                            {currencyFormatter(credit)} ({creditPct}%)
                        </Typography>
                    </Box>
                    <Box className={classes.track}>
                        <Box
                            className={classes.fill}
                            style={{
                                width: `${creditPct}%`,
                                background:
                                    "linear-gradient(90deg, #ff9800, #e65100)",
                            }}
                        />
                    </Box>
                </Box>

                <Box className={classes.row}>
                    <Box className={classes.rowHeader}>
                        <Typography className={classes.label}>
                            {debitLabel}
                        </Typography>
                        <Typography
                            className={classes.amount}
                            style={{ color: "#2e7d32" }}
                        >
                            {currencyFormatter(debit)} ({debitPct}%)
                        </Typography>
                    </Box>
                    <Box className={classes.track}>
                        <Box
                            className={classes.fill}
                            style={{
                                width: `${debitPct}%`,
                                background:
                                    "linear-gradient(90deg, #66bb6a, #2e7d32)",
                            }}
                        />
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ComparisonBar;
